import React, { FC, useEffect, useRef, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core"

interface InfoDialogProps {
    open: boolean
    onClose: () => void
    title: string
    text: string
}

const InfoHelpDialog: FC<InfoDialogProps> = ({ open, onClose, title, text }) => {
  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
        <DialogContent>
            <div id="descriptiontext">{text}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default InfoHelpDialog;